/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../axios";

export default {
  async login({ dispatch }, credentials) {
    let response = await axios.post("/api/auth/login", {
      email: credentials.email,
      password: credentials.password,
    });
    return dispatch("attempt", response.data.token);
  },

  async attempt({ commit }, token) {
    if (!token) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
      return;
    }

    commit("SET_TOKEN", token);

    try {
      let response = await axios.get("/api/auth/user");
      commit("SET_USER", response.data.user);
    } catch (error) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
    }
  },

  logout({ commit }) {
    sessionStorage.clear();
    commit("SET_TOKEN", null);
    commit("SET_USER", null);
  },

  async register({ dispatch }, credentials) {
    let response = await axios.post("/api/auth/signup", {
      name: credentials.name,
      email: credentials.email,
      userType: credentials.userType,
      password: credentials.password,
    });
    return dispatch("attempt", response.data.token);
  },
  async fetchUser({ commit }) {
    try {
      let response = await axios.get("/api/auth/user");
      if (response.data.success) {
        commit("SET_USER", response.data.user);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async fetchAddress({ commit }) {
    let response = await axios.get("/api/address");
    if (response.data.success) {
      commit("SET_ADDRESS", response.data.address[0]);
    }
    return response;
  },
  changePassword({ commit, state }, credentials) {
    return axios
      .post("/api/auth/change-password", {
        email: state.user.email,
        password: credentials.password,
        newPassword: credentials.newPassword,
      })
      .then((response) => {
        if (response.data.success) {
          commit("SET_USER", response.data.user);
          commit("SET_TOKEN", response.data.token);
        }
      });
  },
  setUser({ commit }, user) {
    commit("SET_USER", user);
  },
};
